// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"575":"262832a5d3bbb560","700":"ee20c19c2a678413"}[chunkId] + ".js";
};